var initObj = ['comment','footprint'];

export function lsSearchDisplayInit() {
  localStorage.setItem('SearchDisplay', initObj.join(','));
}
